import React, { FC } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Layout } from 'components/ui';
import { isUserLogged } from 'utils/checkUserStatus';
import { getRoleFromIdToken } from 'utils/getDataFromJwt';

interface AdminRouteProps {
  exact: boolean;
  path: string;
  component: FC;
}

const SuperAdminRoute: FC<AdminRouteProps> = (props: AdminRouteProps) => {
  const { exact, path, component: Component } = props;

  const checkIfUserIsAllowedToDownloadPurchaseIntent = () => {
    const role = getRoleFromIdToken();

    if (role === 'super-admin') {
      return true;
    }

    return false;
  };

  if (!isUserLogged()) {
    return <Redirect to="/login" />;
  }

  if (isUserLogged() && !checkIfUserIsAllowedToDownloadPurchaseIntent()) {
    return <Redirect to="/" />;
  }

  return (
    <Route exact={exact} path={path}>
      <Layout>
        <Component />
      </Layout>
    </Route>
  );
};

export default SuperAdminRoute;
